// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"611d6ebc","536":"a291d9f6","543":"41050d71","663":"26f56082"}[chunkId] + ".chunk.css";
};